import exp from "constants"




export type ColumnType = {
  title: string,
  key: string,
  type: 'text' | 'number' | 'money' | 'date' | 'datetime' | 'boolean' | 'custom',
  options?: any,
  render?: (record:any) => JSX.Element,
  orderable?: boolean | undefined,
  style?: any
}

export type ActionType = {
  title?: string,
  type: 'divider' | 'link',
  action?:string,
  textColor?: string,
  icon?: string,
  condition?: (record:any) => boolean
}

export type FilterType = {
  title: string,
  key: string,
  type: 'select'|'ajaxselect'|'date' ,
  options?: {
    data?: Array<any>,
    apiPath?: string,
    valueField: string,
    labelField: string,
    defaultValue?: any,
    addEmpty?: boolean,
    emptyLabel?: string
  }
}

export const DefaultMenuActions:ActionType[] = [
  {
    title: 'Modifica',
    type: 'link',
    action: 'edit',
    icon: 'fa-solid fa-pencil'
  },
  {
    type: 'divider'
  },
  {
    title: 'Elimina',
    type: 'link',
    action: 'delete',
    textColor: 'danger',
    icon: 'fa-solid fa-trash'
  }
]